import React from 'react';

import ReportAttendanceTable from '../Table';

import { useStyles } from './styles';

export default ({ fields }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ReportAttendanceTable fields={fields} />
    </div>
  );
};
